export default {
  data() {
    return { sortKey: '', sortDirection: 'asc', pageSizeOptions: [5, 10, 15, 50] };
  },
  methods: {
    sortBy(key) {
      if (!key) return;
      if (this.sortKey === key) this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      else { this.sortKey = key; this.sortDirection = 'asc'; }
      if ('currentPage' in this) this.currentPage = 1;
      if ('pagina' in this) this.pagina = 1;
    },
    sortedRows(rows) {
      const list = Array.isArray(rows) ? [...rows] : [];
      if (!this.sortKey) return list;
      const direction = this.sortDirection === 'asc' ? 1 : -1;
      return list.sort((a, b) => {
        const av = a && a[this.sortKey] != null ? a[this.sortKey] : '';
        const bv = b && b[this.sortKey] != null ? b[this.sortKey] : '';
        const an = Number(av), bn = Number(bv);
        if (String(av).trim() && String(bv).trim() && !Number.isNaN(an) && !Number.isNaN(bn)) return (an - bn) * direction;
        return String(av).localeCompare(String(bv), 'es', { numeric: true, sensitivity: 'base' }) * direction;
      });
    },
    sortIcon(key) {
      if (this.sortKey !== key) return 'bi-arrow-down-up';
      return this.sortDirection === 'asc' ? 'bi-sort-up' : 'bi-sort-down';
    },
    onPageSizeChange() {
      if ('currentPage' in this) this.currentPage = 1;
      if ('pagina' in this) this.pagina = 1;
    }
  }
};
